import { defineStyle, defineStyleConfig } from '@chakra-ui/react'

// base
const baseStyle = defineStyle(({ theme }) => {
    const colors = theme.colors

    return {
        _placeholder: { color: colors.captions.placeholder },
        color: colors.green.default,
    }
})

// sizes
const sizes = {
    md: defineStyle({
        padding: '11px 18px',
        height: '120px',
        fontSize: '0.75rem',
        lineHeight: '1.25rem',
        _placeholder: {
            fontSize: '0.75rem',
            lineHeight: '1.25rem',
        },
    }),
    sm: defineStyle({
        padding: '8px',
        height: '90px',
        fontSize: '0.75rem',
        lineHeight: '1.25rem',
        _placeholder: {
            fontSize: '0.75rem',
            lineHeight: '1.25rem',
        },
    }),
    autosize: defineStyle({
        fontSize: '0.6875rem',
        lineHeight: '1.0625rem',
    }),
}

// variants
const variants = {
    filled: defineStyle(({ theme }) => {
        const colors = theme.colors

        return {
            border: '1px solid',
            borderRadius: '8px',
            borderColor: colors.bg['green10'],
            backgroundColor: colors.beige.highlighted,
            _hover: {
                borderColor: colors.captions.disabled,
                backgroundColor: colors.beige.highlighted,
            },
            _focusVisible: {
                borderColor: colors.green.default,
                backgroundColor: colors.beige.highlighted,
            },
            _active: {
                borderColor: colors.green.default,
            },
            _readOnly: {
                pointerEvents: 'none',
            },
            _disabled: {
                cursor: 'not-allowed',
            },
            _invalid: {
                borderColor: colors.orange['100'],
            },
        }
    }),
    autosize: defineStyle(({ theme }) => {
        const colors = theme.colors

        return {
            py: '8px',
            pl: '15px',
            pr: '39px',
            border: '1px solid',
            borderRadius: '8px',
            borderColor: colors.green.transparent_10,
            backgroundColor: colors.beige.highlighted,
            _hover: {
                borderColor: colors.green.transparent_30,
            },
            _focusVisible: {
                borderColor: colors.green.transparent_30,
                outline: 'none',
            },
            _placeholder: {
                color: colors.green.transparent_40,
            },
            resize: 'none',
            fieldSizing: 'content',
            minH: '33px',
            maxH: '165px',
            w: 'full',
            wordBreak: 'break-word',
        }
    }),
}

//
export const Textarea = defineStyleConfig({
    baseStyle,
    sizes,
    variants,
    defaultProps: {
        size: 'md',
        variant: 'filled',
    },
})
